import { React, useEffect, useState, useRef } from "react";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import { LoaderScreen } from "../../components/LoaderScreen";
import { FormatMoney } from "../../../Helpers/FormatNumber";
import { RealizarConteoHeader } from "./RealizarConteoHeader";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import FiltroMultiple from "../../Postventa/Dashboard/Modales/FiltroMultiple";
import { TextField } from "@mui/material";
import RefreshIcon from '@mui/icons-material/Refresh';
import { JustificacionPiezasModal } from "./JustificacionPiezasModal";
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { AñadirNuevaPiezaModal } from "./AñadirNuevaPiezaModal";
import { RealizarConteoHeaderModal } from "./RealizarConteoHeaderModal";
import VisibilityIcon from '@mui/icons-material/Visibility';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import LastPageIcon from '@mui/icons-material/LastPage';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';

export const RealizarConteoScreen = () => {
    const history = useHistory();
    const location = useLocation();
    const folio = location.state?.folio;
    const verResultado = location.state?.verResultado;
    const idsucursal = location.state?.idsucursal;
    const sucursal = location.state?.sucursal;

    const [inventario, setInventario] = useState();
    const [infoHeader, setInfoHeader] = useState();
    const [infoHeaderkpis, setInfoHeaderkpis] = useState();
    const [conteoFisico, setConteoFisico] = useState({});
    const [idInvSelected, setIdInvSelected] = useState();
    const [descripcionSelected, setDescripcionSelected] = useState();
    const [predictivo, setPredictivo] = useState("");
    const [predictivoDebounced, setPredictivoDebounced] = useState(""); // 🔹 valor diferido para filtrar
    const [openJustificacionModal, setOpenJustificacionModal] = useState(false);
    const [openAgregarPiezaModal, setOpenAgregarPiezaModal] = useState(false);
    const [ordenDiferencia, setOrdenDiferencia] = useState(null);
    const [ubicacionesExtra, setUbicacionesExtra] = useState({});
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [openHeaderModal, setOpenHeaderModal] = useState(false);

    // 🔹 PAGINADOR
    const [paginaActual, setPaginaActual] = useState(1);
    const [registrosPorPagina, setRegistrosPorPagina] = useState(50);
    const paginaPreviaRef = useRef(null); // 🔹 página guardada antes de buscar (no provoca renders)
    const scrollContainerRef = useRef(null); // 🔹 referencia al contenedor scrolleable de la tabla
    const scrollPreviaRef = useRef(0);       // 🔹 posición de scroll guardada antes de buscar

    const toggleOrdenDiferencia = () => {
        setOrdenDiferencia((prev) => {
            if (prev === null) return "asc";
            if (prev === "asc") return "desc";
            return null;
        });
    };

    const handleOpenJustificacionModal = (id_inv, descripcion, reg_contado) => {
        if (!reg_contado) {
            Swal.fire({
                title: "CONTEO PENDIENTE",
                text: "Debe realizar el conteo de la pieza antes de justificar la diferencia.",
                icon: "warning",
            });

            return;
        }
        setIdInvSelected(id_inv);
        setDescripcionSelected(descripcion);
        setOpenJustificacionModal(true);
    };

    const handleCloseJustificacionModal = () => {
        setIdInvSelected(0);
        setOpenJustificacionModal(false);
        onExecute(folio);
    };

    const handleOpenAgregarPiezaModal = () => {
        setOpenAgregarPiezaModal(true);
    };

    const handleCloseAgregarPiezaModal = () => {
        setOpenAgregarPiezaModal(false);
        onExecute(folio);
    };

    const handleAddUbicacion = (inv) => {
        setUbicacionesExtra(prev => {
            const actuales = prev[inv.id] || [];
            if (actuales.length >= 5) return prev;
            return {
                ...prev,
                [inv.id]: [...actuales, { ubicacion: "", conteo: "", editing: true }]
            };
        });
    };

    const handleChangeUbicacionExtra = (id, idx, field, value) => {
        setUbicacionesExtra(prev => {
            const copy = [...(prev[id] || [])];
            copy[idx] = { ...copy[idx], [field]: value };
            return { ...prev, [id]: copy };
        });
    };

    const handleSaveUbicacionExtra = async (inv, idx) => {
        const row = ubicacionesExtra[inv.id]?.[idx];
        if (!row?.ubicacion || row?.conteo === "") {
            Swal.fire({
                title: "POSICIÓN",
                text: "Debe ingresar la ubicacion extra de la pieza",
                icon: "warning",
            });

            return;
        }

        // 🔥 VALIDAR CONTEO
        if (Number(row.conteo) <= 0) {

            Swal.fire({
                title: "POSICIÓN",
                text: "El conteo debe ser mayor a 0",
                icon: "warning",
            });

            return;
        }

        setUbicacionesExtra(prev => {
            const copy = [...(prev[inv.id] || [])];
            copy[idx] = { ...copy[idx], editing: false };
            return { ...prev, [inv.id]: copy };
        });

        if (!inv.reg_contado) {
            await handleConteoChange(inv, 0);
        }

        const mdl = {
            id_inv_fisico: inv.id,
            folio: folio,
            posicion_extra: row.ubicacion,
            conteo_fisico: Number(row.conteo || 0),
        };

        try {
            setLoader({ ...loader, mostrar: true });

            const result = await request.post("RealizarConteo/GuardaNuevaPosicion", mdl);

            setLoader({ ...loader, mostrar: false });

            await Swal.fire({
                title: "POSICION",
                text: "Posición agregada con éxito",
                icon: "success",
            });
            onExecute(folio);

        } catch (error) {
            setLoader({ ...loader, mostrar: false });
            Swal.fire("CONTEO", "Error al guardar la ubicación extra", "error");
            console.log(error);
        }
    };

    const handleSaveConteoExtra = async (inv, idx, value) => {
        const row = ubicacionesExtra[inv.id]?.[idx];
        if (!row) return;

        const nuevoValor = value === "" ? null : Number(value);
        const valorActual = row.conteo_db == null ? null : Number(row.conteo_db);

        // En estatus R, si el usuario borró el texto sin confirmar, restaurar al valor de DB
        if (infoHeader?.estatus === "R" && (value === "" || value == null)) {
            setUbicacionesExtra(prev => {
                const copy = [...(prev[inv.id] || [])];
                copy[idx] = { ...copy[idx], conteo: copy[idx].conteo_db };
                return { ...prev, [inv.id]: copy };
            });
            return;
        }

        if (nuevoValor === valorActual) return;

        if (row.conteo_db != null) {
            const confirm = await Swal.fire({
                title: "CONTEO",
                text: "La pieza ya fue contada, ¿Desea modificar el conteo?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, modificar",
                cancelButtonText: "No"
            });

            if (!confirm.isConfirmed) {
                setUbicacionesExtra(prev => {
                    const copy = [...(prev[inv.id] || [])];
                    copy[idx] = { ...copy[idx], conteo: copy[idx].conteo_db };
                    return { ...prev, [inv.id]: copy };
                });
                return;
            }
        }

        const mdl = {
            id_inv_fisico: inv.id,
            folio: folio,
            posicion_extra: row.ubicacion,
            conteo_fisico: nuevoValor,
        };

        try {
            setLoader(prev => ({ ...prev, mostrar: true }));

            const result = await request.post(
                "RealizarConteo/GuardaNuevaPosicion",
                mdl
            );

            setLoader(prev => ({ ...prev, mostrar: false }));

            onExecute(folio);

        } catch (error) {
            setLoader(prev => ({ ...prev, mostrar: false }));
            Swal.fire("ERROR", "No se pudo actualizar", "error");
        }
    };

    const handleCancelUbicacionExtra = (id, idx) => {
        setUbicacionesExtra(prev => {
            const copy = [...(prev[id] || [])];
            copy.splice(idx, 1);
            return { ...prev, [id]: copy };
        });
    };

    const handleDeleteUbicacionExtra = async (inv, idx) => {

        const row = ubicacionesExtra[inv.id]?.[idx];

        if (!row) return;

        const confirm = await Swal.fire({
            title: "Eliminar posición",
            text: "¿Deseas eliminar la ubicación extra?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#d33"
        });

        if (!confirm.isConfirmed) return;

        try {

            setLoader(prev => ({
                ...prev,
                mostrar: true
            }));

            const mdl = {
                id_inv_fisico: inv.id,
                folio: folio,
                posicion_extra: row.ubicacion
            };

            const result = await request.post(
                "RealizarConteo/EliminaNuevaPosicion",
                mdl
            );

            setLoader(prev => ({
                ...prev,
                mostrar: false
            }));
            await Swal.fire({
                title: "POSICION",
                text: "Posición eliminada con éxito",
                icon: "success",
            });

            onExecute(folio);

        } catch (error) {

            setLoader(prev => ({
                ...prev,
                mostrar: false
            }));

            Swal.fire(
                "POSICIÓN",
                "Error al eliminar ubicación extra",
                "error"
            );
        }
    };

    // Activa el modo edición de nombre para una posición extra
    const handleIniciarEdicionNombre = (id, idx) => {
        setUbicacionesExtra(prev => {
            const copy = [...(prev[id] || [])];
            copy[idx] = {
                ...copy[idx],
                editandoNombre: true,
                nombreOriginal: copy[idx].ubicacion,
            };
            return { ...prev, [id]: copy };
        });
    };

    // Cancela la edición de nombre y restaura el valor original
    const handleCancelarEdicionNombre = (id, idx) => {
        setUbicacionesExtra(prev => {
            const copy = [...(prev[id] || [])];
            copy[idx] = {
                ...copy[idx],
                ubicacion: copy[idx].nombreOriginal,
                editandoNombre: false,
                nombreOriginal: undefined,
            };
            return { ...prev, [id]: copy };
        });
    };

    // Confirma la edición de nombre — muestra Swal y llama al endpoint
    const handleConfirmarEdicionNombre = async (inv, idx) => {
        const row = ubicacionesExtra[inv.id]?.[idx];
        if (!row) return;

        const nuevoNombre = row.ubicacion?.trim();
        if (!nuevoNombre) {
            Swal.fire("POSICIÓN", "El nombre de la posición no puede estar vacío", "warning");
            return;
        }

        const confirm = await Swal.fire({
            title: "Modificar posición",
            text: `¿Desea cambiar el nombre de "${row.nombreOriginal}" a "${nuevoNombre}"?`,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, guardar",
            cancelButtonText: "Cancelar",
            confirmButtonColor: "#035917",
        });

        if (!confirm.isConfirmed) return;

        try {
            setLoader(prev => ({ ...prev, mostrar: true }));

            const mdl = {
                id_inv_fisico: inv.id,
                folio: folio,
                posicion_extra: row.nombreOriginal,
                posicion_edit: nuevoNombre,
                id_auditor: 0,
            };

            await request.post("RealizarConteo/EditarNombrePosicion", mdl);

            setLoader(prev => ({ ...prev, mostrar: false }));

            await Swal.fire("POSICIÓN", "Posición actualizada con éxito", "success");

            onExecute(folio);

        } catch (error) {
            setLoader(prev => ({ ...prev, mostrar: false }));
            Swal.fire("POSICIÓN", "Error al actualizar el nombre de la posición", "error");
        }
    };


    const [options, setOptions] = useState({
        familia: [],
        codigo: [],
        um: [],
        ubicacion: [],
        diferencia: []
    });

    const [filtros, setFiltros] = useState({
        familia: [],
        codigo: [],
        um: [],
        ubicacion: [],
        diferencia: []
    });
    const [prioridadFiltros, setPrioridadFiltros] = useState([]);
    const [datosFiltrados, setDatosFiltrados] = useState([]);

    const [filtrosTemp, setFiltrosTemp] = useState({
        familia: [],
        codigo: [],
        um: [],
        ubicacion: [],
        diferencia: []
    });

    const [mostrarFiltro, setMostrarFiltro] = useState({
        familia: { open: false },
        codigo: { open: false },
        um: { open: false },
        ubicacion: { open: false },
        diferencia: { open: false }
    });

    const actualizarPrioridad = (filtro) => {
        setPrioridadFiltros((prev) => {
            const index = prev.indexOf(filtro);

            let nuevasPrioridades;

            // nuevo filtro → se agrega
            if (index === -1) {
                nuevasPrioridades = [...prev, filtro];
            }
            // filtro existente → se cortan los posteriores
            else {
                nuevasPrioridades = prev.slice(0, index + 1);
            }

            // 🔥 LIMPIAR filtros que perdieron prioridad
            setFiltrosTemp((prevTemp) => {
                const limpio = { ...prevTemp };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            // 🔥 LIMPIAR filtros aplicados también
            setFiltros((prevFiltros) => {
                const limpio = { ...prevFiltros };

                Object.keys(limpio).forEach((key) => {
                    if (!nuevasPrioridades.includes(key)) {
                        limpio[key] = [];
                    }
                });

                return limpio;
            });

            return nuevasPrioridades;
        });
    };

    const aplicarFiltros = (data, filtros, _, filtrosPermitidos = []) => {
        let resultado = [...data];

        filtrosPermitidos.forEach((filtro) => {
            if (filtro === "familia" && filtros.familia.length > 0) {
                resultado = resultado.filter((i) => filtros.familia.includes(i.familia));
            }

            if (filtro === "codigo" && filtros.codigo.length > 0) {
                resultado = resultado.filter((i) =>
                    filtros.codigo.includes(i.codigo),
                );
            }

            if (filtro === "um" && filtros.um.length > 0) {
                resultado = resultado.filter((i) =>
                    filtros.um.includes(i.unidad_medida),
                );
            }

            if (filtro === "ubicacion" && filtros.ubicacion.length > 0) {
                resultado = resultado.filter((i) => filtros.ubicacion.includes(i.posicion));
            }

            if (filtro === "diferencia" && filtros.diferencia.length > 0) {
                resultado = resultado.filter((i) => filtros.diferencia.includes(i.tipo_diferencia));
            }
        });

        return resultado;
    };

    // 🔹 DEBOUNCE: espera 300ms tras dejar de teclear antes de aplicar la búsqueda.
    //    El input sigue usando `predictivo` (respuesta inmediata); el filtrado usa
    //    `predictivoDebounced`, evitando recorrer miles de registros en cada tecla.
    //    Si el buscador está vacío, se aplica de inmediato (sin esperar) para que
    //    ningún timer pendiente pise la restauración de página al limpiar.
    useEffect(() => {
        if (predictivo.trim() === "") {
            setPredictivoDebounced("");
            return;
        }
        const timer = setTimeout(() => {
            setPredictivoDebounced(predictivo);
        }, 300);
        return () => clearTimeout(timer);
    }, [predictivo]);

    useEffect(() => {
        if (!Array.isArray(inventario)) return;

        let result = [...inventario];

        prioridadFiltros.forEach((filtro) => {
            switch (filtro) {
                case "familia":
                    if (filtros.familia.length > 0) {
                        result = result?.filter((i) => filtros.familia.includes(i.familia));
                    }
                    break;

                case "codigo":
                    if (filtros.codigo.length > 0) {
                        result = result?.filter((i) =>
                            filtros.codigo.includes(i.codigo),
                        );
                    }
                    break;

                case "um":
                    if (filtros.um.length > 0) {
                        result = result?.filter((i) =>
                            filtros.um.includes(i.unidad_medida),
                        );
                    }
                    break;

                case "ubicacion":
                    if (filtros.ubicacion.length > 0) {
                        result = result?.filter((i) => filtros.ubicacion.includes(i.posicion));
                    }
                    break;

                case "diferencia":
                    if (filtros.diferencia.length > 0) {
                        result = result?.filter((i) => filtros.diferencia.includes(i.tipo_diferencia));
                    }
                    break;

                default:
                    break;
            }
        });

        if (predictivoDebounced.trim() !== "") {

            const texto = predictivoDebounced.toUpperCase().trim();

            result = result.filter((i) =>
                (i.codigo || "")
                    .toUpperCase()
                    .includes(texto)

                ||

                (i.descripcion || "")
                    .toUpperCase()
                    .includes(texto)

                ||

                (i.posicion || "")
                    .toUpperCase()
                    .includes(texto)
            );
        }

        if (ordenDiferencia) {
            result = [...result].sort((a, b) => {
                const montoA = Math.abs((a.diferencia || 0) * (a.costo_unitario || 0));
                const montoB = Math.abs((b.diferencia || 0) * (b.costo_unitario || 0));

                if (ordenDiferencia === "asc") {
                    return montoA - montoB;
                }

                if (ordenDiferencia === "desc") {
                    return montoB - montoA;
                }

                return 0;
            });
        }

        setDatosFiltrados(result);
    }, [inventario, filtros, prioridadFiltros, predictivoDebounced, ordenDiferencia]);

    useEffect(() => {
        if (!Array.isArray(inventario)) return;

        const getBaseData = (filtro) => {
            const index = prioridadFiltros.indexOf(filtro);

            // Si el filtro NO ha sido usado aún → usar data filtrada actual
            if (index === -1) {
                return aplicarFiltros(inventario, filtros, null, prioridadFiltros);
            }

            // Si es el primero → data completa
            if (index === 0) {
                return inventario;
            }

            // Solo aplicar filtros con MAYOR prioridad
            const filtrosPrevios = prioridadFiltros.slice(0, index);

            return aplicarFiltros(inventario, filtros, null, filtrosPrevios);
        };

        // ORIGEN
        const familiaOptions = [
            ...new Set(getBaseData("familia").map((i) => i.familia)),
        ].map((v) => ({ value: v, label: v }));

        const codigoOptions = [
            ...new Set(getBaseData("codigo").map((i) => i.codigo)),
        ].map((v) => ({ value: v, label: v }));

        const umOptions = [
            ...new Set(getBaseData("um").map((i) => i.unidad_medida)),
        ].map((v) => ({ value: v, label: v }));

        const ubicacionptions = [
            ...new Set(getBaseData("ubicacion").map((i) => i.posicion)),
        ].map((v) => ({ value: v, label: v }));

        const diferenciaOptions = [
            ...new Set(getBaseData("diferencia").map((i) => i.tipo_diferencia)),
        ].map((v) => ({
            value: v,
            label:
                v === "S"
                    ? "Sobrante"
                    : v === "F"
                        ? "Faltante"
                        : v === "C"
                            ? "Correcta"
                            : v
        }));

        setOptions({
            familia: familiaOptions,
            codigo: codigoOptions,
            um: umOptions,
            ubicacion: ubicacionptions,
            diferencia: diferenciaOptions
        });
    }, [inventario, filtros, prioridadFiltros]);

    useEffect(() => {
        onExecute(folio);
    }, []);

    // 🔹 PAGINADOR: regresar a la página 1 cuando cambian filtros, orden
    //    o el tamaño de página (evita quedar en páginas vacías).
    //    La búsqueda se maneja aparte en handleBuscarChange para conservar la posición.
    useEffect(() => {
        setPaginaActual(1);
    }, [filtros, prioridadFiltros, ordenDiferencia, registrosPorPagina]);

    const onExecute = (
        folio
    ) => {
        return new Promise((resolve, reject) => {
            setLoader({ ...loader, mostrar: true });

            request
                .get(`ListadoInventarioAuditoria/Inventario?folio=${folio}&resultado=${verResultado}`)
                .then((result) => {
                    if (!result?.listado_inv || result?.listado_inv.length === 0) {
                        Swal.fire({
                            title: "AUDITORÍA",
                            text: "No tiene asignado ningún pasillo en esta auditoría.\nFavor de comunicarse con el auditor responsable.",
                            icon: "warning",
                            confirmButtonText: "Aceptar"
                        });

                        setInventario([]);
                        setLoader({ ...loader, mostrar: false });
                        return;
                    }
                    setInventario(result.listado_inv);
                    setInfoHeader(result.header);
                    setInfoHeaderkpis(result.kpis);
                    setConteoFisico({});
                    const agrupadas = (result.posiciones_extra || []).reduce((acc, item) => {

                        if (!acc[item.id_inv_fisico]) {
                            acc[item.id_inv_fisico] = [];
                        }

                        acc[item.id_inv_fisico].push({
                            ubicacion: item.posicion_extra,
                            conteo: item.conteo_fisico,
                            conteo_db: item.conteo_fisico,
                            bloqueado: item.bloqueado,
                            editing: false
                        });

                        return acc;

                    }, {});

                    setUbicacionesExtra(agrupadas);
                    setLoader({ ...loader, mostrar: false });
                    return;
                })
                .catch((error) => {

                    const mensaje =
                        error?.response?.data ||
                        error?.Mensaje ||
                        "Error al cargar las inventario.";
                    Swal.fire("Inventario", mensaje, "error");
                    setLoader({ ...loader, mostrar: false });
                    return;
                });
        });
    };

    const handleConteoChange = async (inv, value) => {
        const valorNuevo = value === "" || value == null ? null : Number(value);
        const valorActual = inv.conteo_fisico == null ? null : Number(inv.conteo_fisico);

        if (valorNuevo === valorActual) return;

        if (inv.reg_contado) {
            const confirm = await Swal.fire({
                title: "CONTEO",
                text: "La pieza ya fue contada, ¿Desea modificar el conteo?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, modificar",
                cancelButtonText: "No"
            });

            if (!confirm.isConfirmed) {
                // En estatus R el valor original se muestra como placeholder → limpiar el input
                setConteoFisico(prev => ({
                    ...prev,
                    [inv.id]: infoHeader?.estatus === "R" ? "" : (inv.conteo_fisico ?? "")
                }));
                return;
            }
        }
        setLoader({ ...loader, mostrar: true });

        setConteoFisico(prev => ({
            ...prev,
            [inv.id]: value
        }));

        const mdl = {
            id_inv_fisico: inv.id,
            folio: folio,
            id_auditor: 0,
            conteo_fisico: Number(value || 0),
            ubicacion_ok: true,
            modo_captura: "Online",
            id_sesion_off: null,
            observacion: null
        };

        request.post(
            "RealizarConteo/RegistrarConteoOnline",
            mdl
        )
            .then((result) => {

                if (result?.mensaje !== "OK" || result?.resultado !== 0) {
                    Swal.fire(
                        "CONTEO",
                        result?.mensaje || "Ocurrió un problema al registrar el conteo",
                        "warning"
                    );
                    setLoader({ ...loader, mostrar: false });
                    return;
                }

                setInventario(prev =>
                    prev.map(item =>
                        item.id === inv.id
                            ? {
                                ...item,
                                conteo_fisico: Number(value), // 🔥 actualizar el valor confirmado
                                diferencia: result.diferencia,
                                tipo_diferencia: result.tipo_dif,
                                reg_contado: result.reg_contado
                            }
                            : item
                    )
                );

                setLoader({ ...loader, mostrar: false });

            })
            .catch((error) => {
                const mensaje =
                    error?.response?.data ||
                    error?.Mensaje ||
                    "Error al guardar el conteo.";

                Swal.fire("Auditoria", mensaje, "error");
                setLoader({ ...loader, mostrar: false });
            });
    };

    const handleUbicacionOk = (inv) => {
        setLoader({ ...loader, mostrar: true });
        const conteoActual =
            conteoFisico[inv.id] ??
            inv.conteo_fisico ??
            0;

        const nuevoEstado = !inv.ubicacion_ok;

        const mdl = {
            id_inv_fisico: inv.id,
            folio: folio,
            id_auditor: 0,
            conteo_fisico: Number(conteoActual),
            ubicacion_ok: nuevoEstado,
            modo_captura: "Online",
            id_sesion_off: null,
            observacion: null
        };

        request.post(
            "RealizarConteo/RegistrarConteoOnline",
            mdl
        )
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                if (result?.mensaje !== "OK" || result?.resultado !== 0) {
                    Swal.fire(
                        "CONTEO",
                        result?.mensaje || "Ocurrió un problema al registrar el conteo",
                        "warning"
                    );
                    setLoader({ ...loader, mostrar: false });
                    return;
                }
                setInventario(prev =>
                    prev.map(x =>
                        x.id === inv.id
                            ? {
                                ...x,
                                ubicacion_ok: nuevoEstado
                            }
                            : x
                    )
                );

            })
            .catch((error) => {

                const mensaje =
                    error?.response?.data ||
                    error?.Mensaje ||
                    "Error al actualizar ubicación.";

                Swal.fire("Auditoria", mensaje, "error");
            });
    };

    const totals = (datosFiltrados || []).reduce(
        (acc, inv) => {

            const existencia =
                (inv.existencia_orig || 0) -
                (inv.cant_surtido || 0) -
                (inv.cant_transito || 0);

            const conteoPrincipal =
                Number(conteoFisico[inv.id] ?? inv.conteo_fisico ?? 0);

            const conteoExtra =
                (ubicacionesExtra[inv.id] || [])
                    .reduce((sum, row) => sum + Number(row.conteo || 0), 0);

            const conteo = conteoPrincipal + conteoExtra;

            const costo = inv.costo_unitario || 0;
            const justificadas = Number(inv.justificadas || 0);

            acc.existencia += existencia;
            acc.conteo += conteo;
            acc.importe += conteo * costo;
            acc.valorExistencia += existencia * costo;
            acc.justificadas += justificadas;

            const dif = inv.diferencia || 0;
            const monto = Math.abs(dif) * costo;

            if (inv.tipo_diferencia === "S") {
                acc.plus += Math.abs(dif);
                acc.montoS += monto;
            }

            if (inv.tipo_diferencia === "F") {
                acc.minus += Math.abs(dif);
                acc.montoF += monto;
            }

            return acc;
        },
        {
            existencia: 0,
            conteo: 0,
            importe: 0,
            justificadas: 0,
            valorExistencia: 0,
            plus: 0,
            minus: 0,
            montoS: 0,
            montoF: 0,
        }
    );

    // 🔹 PAGINADOR: cálculos de paginación
    //    Los totales se siguen calculando sobre datosFiltrados completo,
    //    aquí solo recortamos lo que se renderiza en la tabla.
    const totalRegistros = datosFiltrados?.length || 0;
    const totalPaginas = Math.max(
        1,
        Math.ceil(totalRegistros / registrosPorPagina)
    );
    // 🔥 Página segura: nunca exceder el total disponible (p. ej. al restaurar
    //    la página previa tras limpiar una búsqueda con menos resultados).
    const paginaSegura = Math.min(paginaActual, totalPaginas);
    const inicioPagina = (paginaSegura - 1) * registrosPorPagina;
    const finPagina = Math.min(inicioPagina + registrosPorPagina, totalRegistros);
    const datosPaginados = (datosFiltrados || []).slice(inicioPagina, finPagina);

    const irPrimeraPagina = () => setPaginaActual(1);
    const irPaginaAnterior = () => setPaginaActual((p) => Math.max(1, p - 1));
    const irPaginaSiguiente = () => setPaginaActual((p) => Math.min(totalPaginas, p + 1));
    const irUltimaPagina = () => setPaginaActual(totalPaginas);

    // 🔹 BUSCADOR: maneja el cambio de texto y la posición de página.
    //    - Al EMPEZAR a buscar (de vacío a con texto): guarda la página actual
    //      en el ref y salta a la 1.
    //    - Al LIMPIAR (de con texto a vacío): restaura la página guardada.
    const handleBuscarChange = (value) => {
        const teniaTexto = predictivo.trim() !== "";
        const tieneTexto = value.trim() !== "";

        if (!teniaTexto && tieneTexto) {
            // arranca una búsqueda nueva (vacío → texto) → guardar página y scroll
            paginaPreviaRef.current = paginaActual;
            scrollPreviaRef.current = scrollContainerRef.current?.scrollTop || 0;
            setPaginaActual(1);
            // al empezar a buscar, subir el scroll al inicio de los resultados
            if (scrollContainerRef.current) {
                scrollContainerRef.current.scrollTop = 0;
            }
        } else if (teniaTexto && !tieneTexto) {
            // el buscador quedó vacío (sin importar si fue de golpe o letra por letra)
            // → cancelar cualquier debounce pendiente y restaurar página + scroll
            setPredictivoDebounced("");
            if (paginaPreviaRef.current !== null) {
                setPaginaActual(paginaPreviaRef.current);
                paginaPreviaRef.current = null;
            }
            // restaurar el scroll DESPUÉS de que la tabla se repinte con todos los
            // registros (si no, el contenedor aún no tiene la altura suficiente)
            const scrollDestino = scrollPreviaRef.current;
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    if (scrollContainerRef.current) {
                        scrollContainerRef.current.scrollTop = scrollDestino;
                    }
                });
            });
            scrollPreviaRef.current = 0;
        }

        setPredictivo(value);
    };

    const handleKeyNavigation = (e) => {
        if (!["Enter", "ArrowDown", "ArrowUp"].includes(e.key)) return;

        e.preventDefault(); // evita que flecha cambie el valor numérico

        const inputs = Array.from(
            document.querySelectorAll(".conteo-fisico-input:not(:disabled)")
        );

        const currentIndex = inputs.indexOf(e.target);
        if (currentIndex === -1) return;

        if (e.key === "ArrowUp") {
            inputs[currentIndex - 1]?.focus();
        } else {
            // Enter o ArrowDown → siguiente
            inputs[currentIndex + 1]?.focus();
        }
    };

    console.log(folio)

    return (
        <PlantillaScreen
            titulo={`CONTEO DE AUDITORIA - ${folio} - ${infoHeader?.sucursal}`}
            className={"conteo-auditoria-main-screen"}
            className_main={1}
        >
            <JustificacionPiezasModal
                open={openJustificacionModal}
                onClose={handleCloseJustificacionModal}
                id_inv={idInvSelected}
                descripcion={descripcionSelected}
                verResultado={verResultado}
            />

            <AñadirNuevaPiezaModal
                open={openAgregarPiezaModal}
                onClose={handleCloseAgregarPiezaModal}
                folio={folio}
            />
            <RealizarConteoHeaderModal
                open={openHeaderModal}
                onClose={() => setOpenHeaderModal(false)}
                info={infoHeader}
                kpis={infoHeaderkpis}
            />
            <div className="conteo-auditoria-actions">
                <div
                    className="conteo-auditoria-actions-regresar"
                    onClick={() => history.goBack()}
                >
                    <ArrowBackIcon /> Regresar
                </div>
            </div>

            {/* <RealizarConteoHeader info={infoHeader} kpis={infoHeaderkpis} /> */}
            <div className="conteo-auditoria">
                <LoaderScreen loader={loader} />
                {/* <div className="conteo-auditoria-filtro">
                   
                </div> */}
                <div className="conteo-auditoria-header-action">

                    <div className="conteo-auditoria-header-action-control">
                        <button
                            className="pa-btn pa-btn--icon"
                            onClick={() => setOpenHeaderModal(true)}
                            title="Ver resumen de auditoría"
                        >
                            <VisibilityIcon />
                        </button>

                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            value={predictivo}
                            onChange={({ target }) => handleBuscarChange(target.value)}
                            placeholder="Buscar pieza por Código, Descripción o Ubicación..."
                            sx={{
                                "& .MuiOutlinedInput-root": {
                                    borderRadius: "8px",
                                    backgroundColor: "#f9f9f9",
                                    fontSize: "13px",
                                    "& fieldset": {
                                        borderColor: "#e0e0e0",
                                    },
                                    "&:hover fieldset": {
                                        borderColor: "#bdbdbd",
                                    },
                                    "&.Mui-focused fieldset": {
                                        borderColor: "#2e7d32",
                                        borderWidth: "1px",
                                    },
                                },
                                "& .MuiInputBase-input": {
                                    color: "#555",
                                    padding: "8px 12px",
                                    "&::placeholder": {
                                        color: "#aaa",
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </div>

                    <div className="avance-conteo-bar-section">
                        <div className="avance-conteo-title">
                            Avance
                        </div>
                        <div className="pa-metric-bar-wrap">
                            <div className="pa-metric-bar">
                                <div
                                    className="pa-metric-bar__fill pa-metric-bar__fill--blue"
                                    style={{ width: `${Math.min(infoHeaderkpis?.avance, 100)}%` }}
                                />
                            </div>
                            <span className="pa-metric-bar__label">
                                {infoHeaderkpis?.avance.toFixed(2)} %
                            </span>
                        </div>

                    </div>

                    {!verResultado && (
                        <button className="pa-btn pa-btn--primary"
                            onClick={() => handleOpenAgregarPiezaModal()}
                        >
                            <AddIcon style={{ fontSize: 18 }} />
                            Nueva pieza
                        </button>
                    )}
                    <button className="pa-btn pa-btn--primary" onClick={() => onExecute(folio)}>
                        <RefreshIcon style={{ fontSize: 18 }} />
                        Recargar
                    </button>
                </div>
                <div className="conteo-auditoria-container scroll-4" ref={scrollContainerRef}>
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    <FiltroMultiple
                                        label="Familia"
                                        field="familia"
                                        options={options.familia}
                                        filtros={filtros}
                                        setFiltros={setFiltros}
                                        filtrosTemp={filtrosTemp}
                                        setFiltrosTemp={setFiltrosTemp}
                                        mostrarFiltro={mostrarFiltro}
                                        setMostrarFiltro={setMostrarFiltro}
                                        actualizarPrioridad={actualizarPrioridad}
                                        setPrioridadFiltros={setPrioridadFiltros}
                                    />
                                </th>
                                <th>
                                    <div className="borde-izq">
                                        <FiltroMultiple
                                            label="Codigo"
                                            field="codigo"
                                            options={options.codigo}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />
                                    </div>
                                </th>
                                <th>
                                    <div className="borde-izq">Descripcion</div>
                                </th>
                                <th>
                                    <div className="borde-izq">Existencia</div>
                                </th>
                                <th>
                                    <div className="borde-izq">
                                        <FiltroMultiple
                                            label="U. M."
                                            field="um"
                                            options={options.um}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />
                                    </div>
                                </th>
                                <th>
                                    <div className="borde-izq">Costo Unitario</div>
                                </th>
                                <th>
                                    <div className="borde-izq">
                                        <FiltroMultiple
                                            label="Ubicacion"
                                            field="ubicacion"
                                            options={options.ubicacion}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />
                                    </div>
                                </th>
                                <th>
                                    <div className="borde-izq">Conteo físico</div>
                                </th>
                                <th>
                                    <div className="borde-izq">Justificadas</div>
                                </th>
                                <th>
                                    <div className="borde-izq th-diferencia">
                                        <FiltroMultiple
                                            label="No Justificadas"
                                            field="diferencia"
                                            options={options.diferencia}
                                            filtros={filtros}
                                            setFiltros={setFiltros}
                                            filtrosTemp={filtrosTemp}
                                            setFiltrosTemp={setFiltrosTemp}
                                            mostrarFiltro={mostrarFiltro}
                                            setMostrarFiltro={setMostrarFiltro}
                                            actualizarPrioridad={actualizarPrioridad}
                                            setPrioridadFiltros={setPrioridadFiltros}
                                        />

                                        <button
                                            className="btn-order-diferencia"
                                            onClick={toggleOrdenDiferencia}
                                        >
                                            {ordenDiferencia === "asc"
                                                ? "↑"
                                                : ordenDiferencia === "desc"
                                                    ? "↓"
                                                    : "⇅"}
                                        </button>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {datosPaginados?.map((inv) => (
                                <tr>
                                    <td
                                        className={`ta-center ${inv.reg_contado ? "td-contado" : ""}`}
                                    >
                                        {inv.familia}
                                    </td>
                                    <td className="ta-left">{inv.codigo}</td>
                                    <td className="ta-left">{inv.descripcion}</td>
                                    <td className="ta-center celda-existencia">
                                        <div className="exist-container">
                                            <div className="exist-container-cant-section">
                                                <span className="existencia">
                                                    {(inv.existencia_orig || 0) - (inv.cant_surtido || 0) - (inv.cant_transito || 0)}
                                                </span>
                                                {(Number(inv.cant_surtido) > 0 || Number(inv.cant_transito) > 0) && (
                                                    <div className="ajustes">
                                                        <span className="flecha">↓</span>
                                                        {Number(inv.cant_surtido) > 0 ? `SU:${inv.cant_surtido}` : ""}
                                                        {Number(inv.cant_surtido) > 0 && Number(inv.cant_transito) > 0 ? " | " : ""}
                                                        {Number(inv.cant_transito) > 0 ? `TR:${inv.cant_transito}` : ""}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="exist-container-monto-section">
                                                $ {FormatMoney(
                                                    ((inv.existencia_orig) - (inv.cant_surtido || 0) - (inv.cant_transito || 0) || 0) * (inv.costo_unitario || 0),
                                                    2
                                                )}
                                            </div>
                                        </div>
                                    </td>
                                    <td className="ta-center">{inv.unidad_medida}</td>
                                    <td className="ta-right">{FormatMoney(inv.costo_unitario, 2)}</td>


                                    <td className="ta-center">
                                        <div className="ubic-container">

                                            {/* Fila principal */}
                                            <div className="ubic-main-row">
                                                <span>{inv.posicion}</span>
                                                {!verResultado && (
                                                    <>
                                                        <button
                                                            className={`ubic-btn ${inv.ubicacion_ok ? "ubic-btn--ok" : "ubic-btn--fail"}`}
                                                            onClick={() => handleUbicacionOk(inv)}
                                                        >
                                                            {inv.ubicacion_ok ? <CheckIcon fontSize="small" /> : <CloseIcon fontSize="small" />}
                                                        </button>
                                                        <button className="ubic-btn ubic-btn--new" onClick={() => handleAddUbicacion(inv)}>
                                                            <AddIcon fontSize="small" />
                                                        </button>
                                                    </>
                                                )}
                                            </div>

                                            {/* Filas extra — solo ubicación, sin conteo */}
                                            {(ubicacionesExtra[inv.id] || []).map((row, idx) => (
                                                <div className="ubic-extra-row">

                                                    <input
                                                        className="ubic-extra-input"
                                                        placeholder="Ubicación"
                                                        value={row.ubicacion}
                                                        disabled={!row.editing && !row.editandoNombre}
                                                        onChange={(e) => handleChangeUbicacionExtra(inv.id, idx, "ubicacion", e.target.value)}
                                                    />

                                                    {/* Botones de nueva posición (modo crear) */}
                                                    {row.editing && (
                                                        <div className="ubic-extra-actions">
                                                            <button
                                                                className="ubic-extra-btn save"
                                                                onClick={() => handleSaveUbicacionExtra(inv, idx)}
                                                            >
                                                                ✔
                                                            </button>
                                                            <button
                                                                className="ubic-extra-btn cancel"
                                                                onClick={() => handleCancelUbicacionExtra(inv.id, idx)}
                                                            >
                                                                ✖
                                                            </button>
                                                        </div>
                                                    )}

                                                    {/* Botones de edición de nombre (modo editar nombre) */}
                                                    {row.editandoNombre && (
                                                        <div className="ubic-extra-actions">
                                                            <button
                                                                className="ubic-extra-btn save"
                                                                title="Confirmar nuevo nombre"
                                                                onClick={() => handleConfirmarEdicionNombre(inv, idx)}
                                                            >
                                                                ✔
                                                            </button>
                                                            <button
                                                                className="ubic-extra-btn cancel"
                                                                title="Cancelar edición"
                                                                onClick={() => handleCancelarEdicionNombre(inv.id, idx)}
                                                            >
                                                                ✖
                                                            </button>
                                                        </div>
                                                    )}

                                                    {/* Botones editar + eliminar — solo cuando no está en ningún modo edición */}
                                                    {!row.bloqueado && !row.editing && !row.editandoNombre && !verResultado && (
                                                        <>
                                                            <button
                                                                className="ubic-extra-btn edit"
                                                                title="Editar nombre de posición"
                                                                onClick={() => handleIniciarEdicionNombre(inv.id, idx)}
                                                            >
                                                                <DriveFileRenameOutlineIcon style={{ fontSize: 13 }} />
                                                            </button>
                                                            <button
                                                                className="ubic-extra-btn cancel"
                                                                title="Eliminar ubicación extra"
                                                                onClick={() => handleDeleteUbicacionExtra(inv, idx)}
                                                            >
                                                                <DeleteIcon style={{ fontSize: 13 }} />
                                                            </button>
                                                        </>
                                                    )}
                                                </div>
                                            ))}

                                        </div>
                                    </td>

                                    <td className="ta-center">
                                        <div className="conteo-fisico-box">

                                            <input
                                                type="number"
                                                min={0}
                                                className="conteo-fisico-input"
                                                disabled={
                                                    (infoHeader?.estatus !== "P" && infoHeader?.estatus !== "R")
                                                    || verResultado
                                                    || inv.bloqueado
                                                }
                                                placeholder={
                                                    infoHeader?.estatus === "R" && inv.reg_contado
                                                        ? String(inv.conteo_fisico ?? 0)
                                                        : "0"
                                                }
                                                value={
                                                    infoHeader?.estatus === "R" && inv.reg_contado && !(inv.id in conteoFisico)
                                                        ? ""
                                                        : (conteoFisico[inv.id] ?? inv.conteo_fisico ?? "")
                                                }
                                                onChange={(e) => setConteoFisico(prev => ({ ...prev, [inv.id]: e.target.value }))}
                                                onWheel={(e) => e.target.blur()}
                                                onBlur={(e) => {
                                                    if (infoHeader?.estatus !== "P" && infoHeader?.estatus !== "R" || verResultado) return;
                                                    const value = e.target.value;
                                                    if (value === "" || value == null) return;

                                                    handleConteoChange(inv, value);
                                                }}
                                                onKeyDown={(e) => {
                                                    if (e.key === "-" || e.key === "+" || e.key === "e") {
                                                        e.preventDefault();
                                                    }
                                                    handleKeyNavigation(e); // 🔥
                                                }}
                                            />

                                            <div className="conteo-fisico-money">
                                                $ {FormatMoney(
                                                    Number(conteoFisico[inv.id] ?? inv.conteo_fisico ?? 0) * (inv.costo_unitario || 0),
                                                    2
                                                )}
                                            </div>

                                            {/* Conteos extra — mismo formato que el conteo principal */}
                                            {(ubicacionesExtra[inv.id] || []).map((row, idx) => (
                                                <>
                                                    <input
                                                        type="number"
                                                        min={0}
                                                        className="conteo-fisico-input"
                                                        disabled={
                                                            row.bloqueado ||
                                                            verResultado ||
                                                            (infoHeader?.estatus !== "P" && infoHeader?.estatus !== "R")
                                                        }
                                                        placeholder={
                                                            row.conteo_db != null
                                                                ? String(row.conteo_db)
                                                                : "0"
                                                        }
                                                        value={
                                                            row.conteo_db != null && !row.editing
                                                                ? (row.conteo === row.conteo_db ? "" : (row.conteo ?? ""))
                                                                : (row.conteo ?? "")
                                                        }
                                                        onChange={(e) =>
                                                            handleChangeUbicacionExtra(inv.id, idx, "conteo", e.target.value)
                                                        }
                                                        onWheel={(e) => e.target.blur()}
                                                        onBlur={(e) => {
                                                            if (
                                                                row.bloqueado ||
                                                                verResultado ||
                                                            (infoHeader?.estatus !== "P" && infoHeader?.estatus !== "R")
                                                            ) return;

                                                            if (row.editing) return;

                                                            handleSaveConteoExtra(inv, idx, e.target.value);
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === "-" || e.key === "+" || e.key === "e") {
                                                                e.preventDefault();
                                                            }
                                                            handleKeyNavigation(e); // 🔥
                                                        }}
                                                    />
                                                    <div className="conteo-fisico-money">
                                                        $ {FormatMoney(Number(row.conteo || 0) * (inv.costo_unitario || 0), 2)}
                                                    </div>
                                                </>
                                            ))}

                                        </div>
                                    </td>
                                    <td className="ta-center">
                                        <div className={`diff-badge diff-badge--justificadas`}
                                            onClick={() => {
                                                // if (verResultado) return;
                                                handleOpenJustificacionModal(inv.id, inv.descripcion, inv.reg_contado);
                                            }}>
                                            {inv.justificadas}
                                        </div>
                                    </td>
                                    <td className="ta-center">
                                        <div className="diff-no-justificadas">

                                            {inv.tipo_diferencia === "S" ? (
                                                <div className="diff-nj-pill diff-nj-pill--plus">
                                                    <span className="diff-nj-sign">+</span>
                                                    <span className="diff-nj-val">
                                                        {Math.abs(inv.diferencia || 0)}
                                                    </span>
                                                </div>
                                            ) : inv.tipo_diferencia === "F" ? (
                                                <div className="diff-nj-pill diff-nj-pill--minus">
                                                    <span className="diff-nj-sign">-</span>
                                                    <span className="diff-nj-val">
                                                        {Math.abs(inv.diferencia || 0)}
                                                    </span>
                                                </div>
                                            ) : (
                                                <div
                                                    className="diff-nj-pill"
                                                    style={{
                                                        background: "#e5e7eb",
                                                        color: "#6b7280"
                                                    }}
                                                >
                                                    <span className="diff-nj-sign">=</span>
                                                    <span className="diff-nj-val">0</span>
                                                </div>
                                            )}

                                            <div className="diff-nj-monto">
                                                $ {FormatMoney(
                                                    Math.abs(inv.diferencia || 0) * (inv.costo_unitario || 0),
                                                    2
                                                )}
                                            </div>

                                        </div>
                                    </td>

                                </tr>
                            ))}
                            <tr>
                                <td className="ta-center" colSpan={3}>Totales:</td>
                                <td className="ta-center celda-existencia">
                                    <div className="exist-container">
                                        <div className="exist-container-cant-section">
                                            <span className="existencia">
                                                {FormatMoney(totals.existencia)}
                                            </span>
                                        </div>

                                        <div className="exist-container-monto-section">
                                            $ {FormatMoney(
                                                totals.valorExistencia,
                                                2
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td colSpan={3}></td>
                                <td className="ta-center">
                                    <div className="conteo-fisico-box">
                                        {totals.conteo}

                                        <div className="conteo-fisico-money">
                                            $ {FormatMoney(
                                                totals.importe,
                                                2
                                            )}
                                        </div>

                                    </div>
                                </td>
                                <td className="ta-center">
                                    <div className={`diff-badge diff-badge--justificadas ${verResultado ? "is-disabled" : ""}`}>
                                        {totals.justificadas}
                                    </div>
                                </td>
                                <td className="ta-center">
                                    <div className="diff-no-justificadas">
                                        <div className="diff-nj-pill diff-nj-pill--plus">
                                            <span className="diff-nj-sign">+</span>
                                            <span className="diff-nj-val">{totals.plus}</span>
                                        </div>
                                        <div className="diff-nj-monto">
                                            $ {FormatMoney((totals.montoS || 0), 2)}
                                        </div>
                                        <div className="diff-nj-pill diff-nj-pill--minus">
                                            <span className="diff-nj-sign">-</span>
                                            <span className="diff-nj-val">{totals.minus}</span>
                                        </div>
                                        <div className="diff-nj-monto">
                                            $ {FormatMoney((totals.montoF || 0), 2)}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    {/* 🔹 PAGINADOR */}
                    <div className="conteo-auditoria-paginador">
                        <div className="conteo-auditoria-paginador__info">
                            Mostrando{" "}
                            {totalRegistros === 0 ? 0 : inicioPagina + 1}
                            {" - "}
                            {finPagina}
                            {" de "}
                            {totalRegistros}
                        </div>

                        <div className="conteo-auditoria-paginador__controls">
                            <select
                                className="conteo-auditoria-paginador__select"
                                value={registrosPorPagina}
                                onChange={(e) => setRegistrosPorPagina(Number(e.target.value))}
                            >
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                            </select>

                            <button
                                className="conteo-auditoria-paginador__btn"
                                onClick={irPrimeraPagina}
                                disabled={paginaSegura === 1}
                                title="Primera página"
                            >
                                <FirstPageIcon fontSize="small" />
                            </button>
                            <button
                                className="conteo-auditoria-paginador__btn"
                                onClick={irPaginaAnterior}
                                disabled={paginaSegura === 1}
                                title="Página anterior"
                            >
                                <ChevronLeftIcon fontSize="small" />
                            </button>

                            <span className="conteo-auditoria-paginador__page">
                                Página {paginaSegura} de {totalPaginas}
                            </span>

                            <button
                                className="conteo-auditoria-paginador__btn"
                                onClick={irPaginaSiguiente}
                                disabled={paginaSegura === totalPaginas}
                                title="Página siguiente"
                            >
                                <ChevronRightIcon fontSize="small" />
                            </button>
                            <button
                                className="conteo-auditoria-paginador__btn"
                                onClick={irUltimaPagina}
                                disabled={paginaSegura === totalPaginas}
                                title="Última página"
                            >
                                <LastPageIcon fontSize="small" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </PlantillaScreen >
    );
};
